import { normalizeLangKey } from './localeLangKey';

export const SERVICE_OPTIONS = [
  { id: 'delivery', ko: '배달', en: 'Delivery', vi: 'Giao hàng', ru: 'Доставка', ja: '配達', 'zh-CN': '外卖', 'zh-TW': '外送', hi: 'डिलीवरी', th: 'เดลิเวอรี', idn: 'Pengantaran' },
  { id: 'pickup', ko: '수거/픽업', en: 'Pickup', vi: 'Lấy hàng', ru: 'Самовывоз', ja: '受け取り', 'zh-CN': '自取', 'zh-TW': '自取', hi: 'पिकअप', th: 'รับเอง', idn: 'Ambil sendiri' },
  { id: 'onsite', ko: '방문서비스', en: 'On-site service', vi: 'Dịch vụ tại chỗ', ru: 'Услуга на месте', ja: '訪問サービス', 'zh-CN': '上门服务', 'zh-TW': '到府服務', hi: 'ऑन-साइट', th: 'บริการถึงที่', idn: 'Layanan di tempat' },
  { id: 'reservation', ko: '예약가능', en: 'Reservation', vi: 'Có thể đặt trước', ru: 'Бронирование', ja: '予約可', 'zh-CN': '可预约', 'zh-TW': '可預約', hi: 'आरक्षण', th: 'จองได้', idn: 'Bisa reservasi' },
  { id: 'same_day', ko: '당일가능', en: 'Same-day', vi: 'Trong ngày', ru: 'В тот же день', ja: '当日可', 'zh-CN': '当天可', 'zh-TW': '當日可', hi: 'उसी दिन', th: 'วันเดียวกัน', idn: 'Hari yang sama' },
  { id: 'weekend', ko: '주말가능', en: 'Weekend available', vi: 'Cuối tuần', ru: 'Доступно по выходным', ja: '週末可', 'zh-CN': '周末可', 'zh-TW': '週末可', hi: 'सप्ताहांत', th: 'สุดสัปดาห์', idn: 'Akhir pekan' },
];

export function getServiceOptionLabel(optionId, language = 'ko') {
  const option = SERVICE_OPTIONS.find((x) => x.id === optionId);
  if (!option) return optionId;
  const lang = normalizeLangKey(language);
  const key = lang === 'id' ? 'idn' : lang;
  return option[key] || option.en || option.ko || optionId;
}

